/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCardSkinsRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_card_skins.pb'
import {GetCardSkinsResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_card_skins.pb'


export const getCardSkins = (request: GetCardSkinsRequest, options?: CashRequestOptions) => post<GetCardSkinsRequest, GetCardSkinsResponse>("/2.0/cash/get-card-skins", request, {...options, rejectOnError: true })